/** Esqueci minha senha — chamadas públicas, sem token. */

import { api } from './client';

export interface RespostaEsqueci {
  email_mascarado: string;
  validade_minutos: number;
}

export interface LinkDeRedefinicao {
  nome: string;
  email_mascarado: string;
  primeiro_acesso: boolean;
  expira_em: string;
}

export const ApiSenha = {
  esqueci: async (loja: string, identificador: string): Promise<RespostaEsqueci> =>
    (await api.post<RespostaEsqueci>('/auth/esqueci-senha', { loja, identificador })).data,
  conferir: async (loja: string, token: string): Promise<LinkDeRedefinicao> =>
    (await api.get<LinkDeRedefinicao>('/auth/redefinir-senha', { params: { loja, token } })).data,
  redefinir: async (loja: string, token: string, senhaNova: string): Promise<void> => {
    await api.post('/auth/redefinir-senha', { loja, token, senha_nova: senhaNova });
  },
};
